import { LiteRouter } from '@/utils'
import LandingPage from '@/views/landing-page'
import RegisterPage from '@/views/register-page'

let $router: LiteRouter

export default (skipLanding: boolean) => {
  const routes = skipLanding
    ? [
        // 注册页
        {
          path: '/',
          component: RegisterPage,
        },
      ]
    : [
        // 注册页路由
        {
          path: '/register',
          component: RegisterPage,
        },
        // 落地页路由
        {
          path: '/',
          component: LandingPage,
        },
      ]
  $router = new LiteRouter({
    routerView: '#root',
    routes,
  })
}
export const useRouter = () => $router
